import { z } from 'zod';

/** Public tenant job id (container slot scan + wafer transfer). Format: job-{ms}-{suffix} */
export const publicTenantJobIdSchema = z
  .string()
  .regex(/^job-\d+-[a-z0-9]+$/, 'Invalid jobId format');

/** Route param for any tenant EFEM job id. */
export const tenantJobIdParamSchema = z.object({
  jobId: publicTenantJobIdSchema,
});

export const waferTransferJobIdParamSchema = tenantJobIdParamSchema;
// Inferred types
export type publicTenantJobId = z.infer<typeof publicTenantJobIdSchema>;
export type tenantJobIdParam = z.infer<typeof tenantJobIdParamSchema>;
export type waferTransferJobIdParam = z.infer<typeof waferTransferJobIdParamSchema>;
